/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-useless-escape */
import { useState, useCallback } from "react";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";

import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import {
  Create,
  Add as AddIcon,
  Visibility as VisibilityIcon,
} from "@material-ui/icons";

import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";

import {
  columnTextField,
  columnCNPJCPFWithCopyField,
} from "utils/tables-utils";
import DialogTrocaDevolucaoUsuario from "components/Dialogs/DialogTrocaDevolucaoUsario";
import DialogTrocaDevolucaoDetalhePedido from "components/Dialogs/DialogTrocaDevolucaoDetalhePedido";
import ProductEditExchangeDialog from "components/Dialogs/DialogEdicaoTrocaDevolucaoPedido";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);

const columnModel = (setSelectedStore, setType) => [
  columnTextField(
    {
      dataField: "NomeConsumidor",
      text: "Consumidor",
    },
    false
  ),
  columnCNPJCPFWithCopyField({
    dataField: "CpfConsumidor",
    text: "CPF/CNPJ Consumidor",
    csvExport: false,
  }),
  columnTextField(
    {
      dataField: "NomeLoja",
      text: "Razão Social",
    },
    false
  ),
  columnTextField(
    {
      dataField: "Apelido",
      text: "Apelido",
    },
    false
  ),
  columnCNPJCPFWithCopyField({
    dataField: "CnpjLoja",
    text: "CNPJ Lojista",
    csvExport: false,
  }),
  columnTextField(
    {
      dataField: "IdTrocaDevolucao",
      text: "Número da Troca",
      align: "center",
    },
    false
  ),
  columnTextField(
    {
      dataField: "DataInclusaoFormat",
      text: "Data Inclusão",
      align: "center",
    },
    false
  ),
  {
    dataField: "visualizar",
    text: "",
    isDummyField: true,
    csvExport: false,
    headerStyle: { width: 45 },
    formatter: (cell, row) => {
      return (
        <Tooltip title="Visualizar Detalhes da Troca/Devolução">
          <IconButton
            aria-label="view"
            onClick={() => {
              setSelectedStore(row);
              setType("view");
            }}
          >
            <Box
              component={VisibilityIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "adicionar",
    text: "",
    isDummyField: true,
    csvExport: false,
    headerStyle: { width: 30 },
    formatter: (cell, row) => {
      return (
        <Tooltip
          title={
            row?.NumeroNF !== "" || row?.ListDevolucaoTroca?.length === 0
              ? "Não é possível adicionar itens na Troca/Devolução"
              : "Adicionar itens na Troca/Devolução"
          }
        >
          <IconButton
            aria-label="addItem"
            disabled={Boolean(
              row.NumeroNF !== "" || row?.ListDevolucaoTroca?.length === 0
            )}
            onClick={() => {
              setSelectedStore(row);
              setType("addItem");
            }}
          >
            <Box
              component={AddIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 30 },
    formatter: (cell, row) => {
      return (
        <Tooltip
          title={
            row?.NumeroNF !== "" || row?.ListDevolucaoTroca?.length === 0
              ? "Não é possível editar a Troca/Devolução"
              : "Editar Troca/Devolução"
          }
        >
          <span>
            <IconButton
              aria-label="edit"
              disabled={Boolean(
                row.NumeroNF !== "" || row?.ListDevolucaoTroca?.length === 0
              )}
              onClick={() => {
                setSelectedStore(row);
                setType("edit");
              }}
            >
              <Box
                component={Create}
                width="1.25rem!important"
                height="1.25rem!important"
              />
            </IconButton>
          </span>
        </Tooltip>
      );
    },
  },
];

export default function TableTrocasDevolucoes({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  search,
}) {
  const classes = useStyles();
  const isMobile = IsMobile();

  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [type, setType] = useState("");

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await search({ page, sizePerPage });

    setLoading(false);
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <>
      <ToolkitTable
        searched={Boolean(dataTable)}
        keyField="id"
        dataTable={dataTable}
        columnModel={columnModel(setPedidoSelecionado, setType)}
        allowEmpty
        headerTitle="Trocas / Devoluções"
        styledRow={{
          cursor: "pointer",
        }}
        loading={loading}
        pagination={{
          options: [25, 50, 100],
          defaultOption: currentSizePerPage,
          totalSize: totalRegistros,
          showTotal: true,
          page: currentPage,
          onPageChange: handlePageChange,
          sizePerPage: currentSizePerPage,
          onSizePerPageChange: handleSizePerPageChange,
        }}
        bootstrapTableProps={{
          remote: true,
          onTableChange: () => {},
        }}
        notFoundTitle="Sua busca não encontrou nenhum resultado correspondente."
        CustomHeader={() => (
          <Grid
            container
            className="pl-4"
            style={{
              padding: isMobile ? "0" : "0 24px",
              display: "flex",
              alignItems: isMobile ? "flex-start" : "center",
              flexDirection: isMobile ? "column" : "row",
              marginBottom: !isMobile && "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Box
                component={Typography}
                variant="h3"
                marginBottom="0!important"
              >
                <Box component="span">Trocas / Devoluções</Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: 0,
                marginTop: isMobile && "1rem",
                marginBottom: isMobile ? "1rem" : "0.5rem!important",
              }}
            >
              <Box
                justifyContent={isMobile ? "flex-start" : "flex-end"}
                alignItems="center"
                display="flex"
                flexWrap="wrap"
                style={{
                  marginLeft: isMobile ? 10 : 15,
                  marginRight: isMobile ? 5 : 15,
                  cursor: "pointer",
                }}
              >
                <Button
                  variant="contained"
                  classes={{
                    root: classes.buttonRootWhite,
                  }}
                  onClick={() => {
                    setOpenDialog(true);
                    setType("create");
                  }}
                  style={{ marginRight: "1rem" }}
                >
                  <Box component={AddIcon} position="relative" top="-2px" />{" "}
                  Solicitar Troca / Devolução
                </Button>
              </Box>
            </Grid>
          </Grid>
        )}
      />
      {openDialog && type === "create" && (
        <DialogTrocaDevolucaoUsuario
          type={type}
          onClose={(idPedido) => {
            setOpenDialog(false);
            if (idPedido) {
              search({
                numeroPedido: idPedido,
                page: currentPage,
                sizePerPage: currentSizePerPage,
              });
            }
          }}
        />
      )}
      {pedidoSelecionado && type === "addItem" && (
        <DialogTrocaDevolucaoUsuario
          type={type}
          idPedido={pedidoSelecionado?.ListDevolucaoTroca[0]?.IdPedido}
          onClose={(idPedido) => {
            setPedidoSelecionado(null);
            if (idPedido) {
              search({
                numeroPedido: idPedido,
                page: currentPage,
                sizePerPage: currentSizePerPage,
              });
            }
          }}
        />
      )}
      {pedidoSelecionado && type === "view" && (
        <DialogTrocaDevolucaoDetalhePedido
          idDevolucao={pedidoSelecionado?.IdTrocaDevolucao}
          pedido={pedidoSelecionado}
          onClose={({ idTrocaDevolucao, refresh }) => {
            setPedidoSelecionado(null);
            if (idTrocaDevolucao) {
              search({
                numeroTroca: idTrocaDevolucao,
                page: currentPage,
                sizePerPage: currentSizePerPage,
              });
            }

            if (refresh) {
              search({ page: currentPage, sizePerPage: currentSizePerPage });
            }
          }}
        />
      )}
      {pedidoSelecionado && type === "edit" && (
        <ProductEditExchangeDialog
          idDevolucao={pedidoSelecionado?.IdTrocaDevolucao}
          idPessoaLoja={pedidoSelecionado?.IdPessoaLoja}
          itens={pedidoSelecionado}
          onClose={(idTrocaDevolucao) => {
            setPedidoSelecionado(null);
            if (idTrocaDevolucao) {
              search({
                numeroTroca: idTrocaDevolucao,
                page: currentPage,
                sizePerPage: currentSizePerPage,
              });
            }
          }}
        />
      )}
    </>
  );
}
